import { BookMarked } from "lucide-react";

// Logo « Le Passeport » : tuile bleu profond + glyphe carnet. Identité de marque.
export function Logo({ size = 56 }) {
  return (
    <div
      className="flex items-center justify-center rounded-2xl bg-blue-900 text-white shadow-lg shadow-blue-900/20 dark:bg-blue-500 dark:shadow-blue-500/20"
      style={{ width: size, height: size }}
      data-testid="app-logo"
      aria-label="Logo Le Passeport"
    >
      <BookMarked strokeWidth={1.75} style={{ width: size * 0.5, height: size * 0.5 }} />
    </div>
  );
}
